import React, { useState } from "react";
import { Checkbox, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { errorAction, successAction, types as at } from "@authzsvc/api-lib";
import { patchComputingGroup } from "../../actions/api";
import { showErrorNotification } from "../../util";

function ComputingGroupAction({
  groupComputingGroup,
  groupId,
  patchComputingGroup,
}) {
  const [checked, setChecked] = useState(groupComputingGroup);
  const [disabled, setDisabled] = useState(groupComputingGroup);

  const changeCheckedStatus = async () => {
    const fields = [
      { path: "isComputingGroup", op: "replace", value: "true" },
      { path: "gid", op: "replace", value: null },
    ];
    const result = await patchComputingGroup(groupId, fields);
    if (result.type === successAction(at.PATCH_GROUP_BY_ID)) {
      setChecked(true);
      setDisabled(true);
    } else if (result.type === errorAction(at.PATCH_GROUP_BY_ID)) {
      showErrorNotification(result.payload.title, result.payload.data.message);
    }
  };

  const showConfirmModal = () => {
    Modal.confirm({
      title: (
        <>
          <ExclamationCircleOutlined
            style={{
              marginRight: 8,
              color: "#faad14",
            }}
          />
          Warning
        </>
      ),
      content:
        "Once you proceed with this action, your choice cannot be reversed!",
      okText: "Accept",
      onOk: changeCheckedStatus,
      centered: true,
      icon: null,
    });
  };

  return (
    <Checkbox
      onChange={showConfirmModal}
      checked={checked}
      disabled={disabled}
    />
  );
}

ComputingGroupAction.propTypes = {
  groupId: PropTypes.string,
  groupComputingGroup: PropTypes.bool,
};

export default connect(null, { patchComputingGroup })(ComputingGroupAction);
